import { IApiError } from '@/models/apiError.model';
import { ILLMTemplateVariable } from '@/models/llmTemplate.model';

export const SLICE_NAME = 'llmTemplateVariables';

export interface LLMTemplateVariablesState {
  variables: ILLMTemplateVariable[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: LLMTemplateVariablesState = {
  variables: null,
  isLoading: false,
  error: null,
};
